<template>
  <v-icon>
    <slot></slot>
  </v-icon>
</template>

<script>
export default {
  name: "AppIcon",
};
</script>
